/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

export const extractContentId = (initData: Uint8Array) => {
  const uriParts = arrayToString(initData).split(";", 2);
  return uriParts.length > 1 ? uriParts[1] : "";
};

export const concatInitDataIdAndCertificate = (
  initData: Uint8Array,
  contentId: string,
  cert: Uint8Array,
) => {
  const id = stringToArray(contentId);

  const buffer = new ArrayBuffer(
    initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength,
  );

  const dataView = new DataView(buffer);
  let offset = 0;

  // Copy initData
  new Uint8Array(buffer, offset, initData.byteLength).set(initData);
  offset += initData.byteLength;

  // Write id length and data
  dataView.setUint32(offset, id.byteLength, true);
  offset += 4;
  new Uint16Array(buffer, offset, id.length).set(id);
  offset += id.byteLength;

  // Write cert length and data
  dataView.setUint32(offset, cert.byteLength, true);
  offset += 4;
  new Uint8Array(buffer, offset, cert.byteLength).set(cert);

  return new Uint8Array(buffer);
};

export const arrayToString = (array: Uint8Array) => {
  return Array.from(new Uint16Array(array.buffer), (code) =>
    String.fromCharCode(code),
  ).join("");
};

export const stringToArray = (string: string) => {
  return Uint16Array.from(string, (char) => char.charCodeAt(0));
};
